import * as React from "react";
import { CategoryCard } from "../../../types/CategoriesCard";
import "../Component.css";

interface Props {
	category: CategoryCard;
	onClick: (id: number) => void;
}

const Category: React.FC<Props> = ({ category, onClick }) => {
	return (
		<div className="categoriesCard-category" onClick={() => onClick(category.category.id)}>
			<div className="categoriesCard-category__name">
				{category.category.name}
			</div>

			<div className="categoriesCard-category__progress">
				<div
					className="categoriesCard-category__bar"
					style={{ width: `${category.percent}%` }}
				/>
			</div>

			<div className="categoriesCard-category__count">{category.percent}%</div>
		</div>
	);
};

export default Category;
